export default function transformEditorPopupLink(linkHtml) {
  return linkHtml?.replace(/href="(\d+)"/g, 'href="javascript:void(0);popupOverlayId=$1"');
}
